import React, { useContext } from 'react';
import { Layout, Cell, Box, Heading, Divider } from 'wix-style-react';
import { useExperiments } from '@wix/wix-experiments-react';
import { PluginCard } from './pluginCard';

import { usePluginsByInterfaces } from '../hooks/usePluginsByInterfaces';
import { useTranslation } from '../../useTranslation';
import { PluginsContext } from '../pluginsContext';

const ITexts: {
  [key: string]: string;
} = {
  DEFAULT: 'PLATFORM_Widget_Slots_Plugin_Type_default',
  NONE: 'PLATFORM_Widget_Slots_Plugin_Type_universal',
  ENV: 'PLATFORM_Widget_Slots_Plugin_Type_environment',
  RATINGS_SUMMARY: 'PLATFORM_Widget_Slots_Plugin_Type_ratings',
  RATINGS_SUMMARY_OOI_LIST: 'PLATFORM_Widget_Slots_Plugin_Type_ratings',
  RESOURCE: 'PLATFORM_Widget_Slots_Plugin_Type_resource',
  REVIEWS: 'PLATFORM_Widget_Slots_Plugin_Type_reviews',
  CHECKOUT_WIDGET: 'PLATFORM_Widget_Slots_Plugin_Type_checkout_widget',
  EVENT_DETAILS: 'PLATFORM_Widget_Slots_Plugin_Type_event_details',
};

export const PluginsGrid = () => {
  const pluginsMap = usePluginsByInterfaces();
  const { plugins } = useContext(PluginsContext);
  const interfaces = Object.keys(pluginsMap);
  const [t] = useTranslation();

  const { experiments } = useExperiments();
  const disableGroupingByInterface = experiments.enabled(
    'specs.pluginsMarket.disableGroupingByInterface',
  );
  return disableGroupingByInterface ? (
    <>
      <Box direction="vertical" marginBottom="SP3" marginTop="SP3"></Box>
      <Layout gap="24px" cols={12}>
        {plugins.map((plugin) => (
          <Cell span={4} rows={1} key={plugin.id}>
            <PluginCard plugin={plugin} />
          </Cell>
        ))}
      </Layout>
      <Box direction="vertical" marginTop="SP5"></Box>
    </>
  ) : (
    <>
      {interfaces.map((intrf, index) => (
        <React.Fragment key={intrf}>
          <Box direction="vertical" marginBottom="SP3" marginTop="SP3">
            <Heading appearance="H3">{t(ITexts[intrf])}</Heading>
          </Box>
          <Layout gap="24px" cols={12}>
            {pluginsMap[intrf].map((plugin) => (
              <Cell span={4} rows={1} key={plugin.id}>
                <PluginCard plugin={plugin} />
              </Cell>
            ))}
          </Layout>
          {index !== interfaces.length - 1 && (
            <Box direction="vertical" marginTop="SP5">
              <Divider />
            </Box>
          )}
        </React.Fragment>
      ))}
    </>
  );
};
